// extracted by css-extract-rspack-plugin
export default {"form":"wfKP5rMfssYZL_ry","delete":"HMFoUgB54WCmH431","btn":"HykZNCL26n86JGKy"};